import { ReactNode } from "react";
import urljoin from "url-join";
import { Dimension, MimeType } from "js/models";

export interface AppBreadcrumb {
    displayName: string;
    id: string;
    icon?: ReactNode;
}

export function getMediaContentPrefix(_path: string) {
    const p = urljoin(_path, "/");
    return p === "/" ? "" : p;
}

export function getMediaContentRelPath(prefix: string, rel: string) {
    return urljoin(getMediaContentPrefix(prefix), rel);
}
export function getAssetType(key: string) {
    if (key == null) {
        key = "";
    }
    const type = key.split(".");
    if (type.length > 1) {
        const ext = type[type.length - 1].toLowerCase();
        if (ext.includes("mp4")) {
            return MimeType.MP4;
        } else if (ext.includes("webm")) {
            return MimeType.Webm;
        } else if (ext.includes("png")) {
            return MimeType.PNG;
        } else if (ext.includes("gif")) {
            return MimeType.GIF;
        } else if (["jpg", "jpeg"].includes(ext)) {
            return MimeType.JPEG;
        }
    }

    return null;
}
